import React from 'react';
import {Route} from 'react-router-dom';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';
import AsyncPage from './async';

export default (
  <Route key="/consumer/features/ai-headshot-generator" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/ai-headshot-generator" element={<AsyncPage />} />
  </Route>
);
